import { FlattenMaps } from 'mongoose';

import * as routes from 'api/routes';
import { IModel } from 'models/fake_coming_soon_slides/interface';

export type Params = any;
export type Result = Array<FlattenMaps<IModel>>;

export const WEBSITE_ROUTE = routes.WEBSITE_FAKE_COMING_SOON_SLIDES_GET_ALL;
